import React from 'react'

const GamingHeaderIcon = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="gaming-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(156, 39, 176, 1)" />
          <stop offset="100%" stopColor="rgba(123, 31, 162, 1)" />
        </linearGradient>
        <filter id="gaming-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Controller body */}
      <path 
        d="M4 14C4 11.7909 5.79086 10 8 10H24C26.2091 10 28 11.7909 28 14V18C28 20.2091 26.2091 22 24 22H8C5.79086 22 4 20.2091 4 18V14Z" 
        stroke="url(#gaming-grad)" 
        strokeWidth="2"
        filter="url(#gaming-glow)"
      />
      
      {/* D-pad left side */}
      <line x1="10" y1="16" x2="14" y2="16" stroke="url(#gaming-grad)" strokeWidth="2" strokeLinecap="round"/>
      <line x1="12" y1="14" x2="12" y2="18" stroke="url(#gaming-grad)" strokeWidth="2" strokeLinecap="round"/>
      
      {/* Buttons right side */}
      <circle cx="20" cy="14" r="1.5" fill="url(#gaming-grad)"/>
      <circle cx="23" cy="16" r="1.5" fill="url(#gaming-grad)"/>
      <circle cx="20" cy="18" r="1.5" fill="url(#gaming-grad)"/>
      <circle cx="17" cy="16" r="1.5" fill="url(#gaming-grad)"/>
      
      {/* Grips */}
      <path d="M8 22C6 23 4 24 4 26" stroke="url(#gaming-grad)" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
      <path d="M24 22C26 23 28 24 28 26" stroke="url(#gaming-grad)" strokeWidth="2" strokeLinecap="round" opacity="0.7"/>
      
      {/* Energy lines */}
      <path d="M16 6L16 10" stroke="url(#gaming-grad)" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
      <path d="M12 7L11 10" stroke="url(#gaming-grad)" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      <path d="M20 7L21 10" stroke="url(#gaming-grad)" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
      
      {/* Power dots */}
      <circle cx="16" cy="4" r="1.5" fill="url(#gaming-grad)" opacity="0.8"/>
    </svg>
  )
}

export default GamingHeaderIcon
